import React from 'react'
import { string, func } from 'prop-types'
import styled, { css } from 'styled-components'

import { media } from 'styles/media'
import { white } from 'styles/colors'
import { cover } from 'styles/global'
import * as spacing from 'styles/spacing'
import { H1, H3 } from 'styles/typography'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background: ${props => props.background};
  user-select: none;
  width: 100%;
  height: 100%;
  padding-top: 64px;
  padding-bottom: 140px;

  ${media.small`
    padding-top: 72px;
  `};
`

const Inner = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  padding: 0 ${spacing.xxLarge};
`

const ImageWrap = styled.div`
  position: relative;
  width: 190px;
  margin-bottom: ${spacing.medium};
  margin-left: auto;
  margin-right: auto;

  ${media.small`
    width: 220px;
    margin-bottom: ${spacing.xLarge};
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
    width: 100%;
  }
`

const Image = styled.img`
  width: 100%;
  ${cover('absolute')};
  object-fit: cover;

  ${props =>
    props.isFlavour &&
    css`
      border-radius: 50%;
      filter: drop-shadow(3px 6px 20px rgba(0, 0, 0, 0.3));
    `}
`

const Name = styled(H1)`
  display: block;
  font-size: 40px;
  text-transform: uppercase;
  color: ${white};
  font-family: 'Trim Poster';

  ${media.small`
    font-size: 48px;
  `};
`

const Description = styled.p`
  color: ${white};
  margin-bottom: 0.75em;
`

const Price = styled(H3)`
  color: ${white};
  margin-bottom: 1em;
  display: block;
`

const Background = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 140px);
  object-fit: cover;
  mix-blend-mode: screen;
  opacity: 0.1;
  pointer-events: none;
`

const CarouselSlide = ({ name, background, onClick, slug, link, price, description }) => {
  const isFlavour = slug !== 'nicotine-free'
  return (
    <Container background={background} onClick={onClick}>
      <Inner>
        <ImageWrap>
          <Image src={`${process.env.BASE_PATH}/images/home/offers/flavours/${slug}.png`} isFlavour={isFlavour} />
        </ImageWrap>
        <Name as="span">
          <span dangerouslySetInnerHTML={{ __html: name }} />
        </Name>
        <Description>{description}</Description>
        <Price as="span">{price}</Price>

        <Button to={link} theme="custom" variant="outline" customColor={white} size="large">
          Buy now
        </Button>
      </Inner>
      <Background src={`${process.env.BASE_PATH}/images/home/offers/shape.svg`} />
    </Container>
  )
}

CarouselSlide.propTypes = {
  name: string.isRequired,
  background: string.isRequired,
  slug: string.isRequired,
  link: string.isRequired,
  price: string.isRequired,
  description: string.isRequired,
  onClick: func.isRequired
}

export default CarouselSlide
